import { createContext } from 'react';

const BannerContext = /*#__PURE__*/createContext(false);

export { BannerContext };
